import { useState } from "react";
import { MailWarning, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function EmailVerifyNotice({ className = "" }) {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      toast.success(data.message);
      refresh();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`rounded-2xl border border-[#c9a96e] bg-white p-4 ${className}`} data-testid="email-verify-notice">
      <div className="flex gap-3">
        <MailWarning size={20} className="mt-0.5 shrink-0 text-[#b8975a]" />
        <div className="space-y-1.5 text-sm text-[#0d2517]">
          <p className="font-semibold">Conferma il tuo indirizzo email</p>
          <p className="text-[#2D3A30]">
            Ti abbiamo inviato un link di conferma a <strong data-testid="email-verify-address">{user.email}</strong>. Finché non confermi l'indirizzo non puoi avviare analisi né acquistare pacchetti. Se non trovi l'email, controlla anche la cartella spam.
          </p>
        </div>
      </div>
      <button onClick={resend} disabled={busy} className="btn-secondary mt-3 w-full bg-white" data-testid="email-verify-resend-button">
        <Send size={15} /> {busy ? "Invio in corso…" : "Invia nuovamente l'email"}
      </button>
    </div>
  );
}
